import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { convertToError } from '../../error-handling/convert-to-error';
import { NO_RETRIES } from './constants';
import FailedFetchError from './errors/FailedFetchError';
export var wait = function wait(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
};
var NO_CALLS_ERROR = 'No calls made';
var retryOnException = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(invokeOperation, _ref) {
    var _ref$intervalsMS, intervalsMS, _ref$retryOn, retryOn, captureException, onRetry, intervals, nextMSInterval, error;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          _ref$intervalsMS = _ref.intervalsMS, intervalsMS = _ref$intervalsMS === void 0 ? NO_RETRIES : _ref$intervalsMS, _ref$retryOn = _ref.retryOn, retryOn = _ref$retryOn === void 0 ? [FailedFetchError] : _ref$retryOn, captureException = _ref.captureException, onRetry = _ref.onRetry;
          intervals = _toConsumableArray(intervalsMS);
          nextMSInterval = 0;
          error = new Error(NO_CALLS_ERROR);
        case 4:
          if (!(nextMSInterval !== undefined)) {
            _context.next = 22;
            break;
          }
          _context.prev = 5;
          if (!(nextMSInterval > 0)) {
            _context.next = 9;
            break;
          }
          _context.next = 9;
          return wait(nextMSInterval);
        case 9:
          if (onRetry && error.message !== NO_CALLS_ERROR) {
            onRetry(error);
          }
          _context.next = 12;
          return invokeOperation();
        case 12:
          return _context.abrupt("return", _context.sent);
        case 15:
          _context.prev = 15;
          _context.t0 = _context["catch"](5);
          error = convertToError(_context.t0);
          if (captureException) {
            captureException(error);
          }

          // Retry ONLY when the error is an instance of one of the provided `retryOn` errors, or passes the `retryOn` test.
          // You need to ensure you are throwing one of the `retryOn` errors if that is the method you are using.
          if (typeof retryOn === 'function' ? retryOn(error) : retryOn.some(function (err) {
            return error instanceof err;
          })) {
            nextMSInterval = intervals.shift();
          } else {
            nextMSInterval = undefined;
          }
        case 20:
          _context.next = 4;
          break;
        case 22:
          throw error;
        case 23:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[5, 15]]);
  }));
  return function retryOnException(_x, _x2) {
    return _ref2.apply(this, arguments);
  };
}();
export { FailedFetchError, retryOnException };